class downloadRecordCtrl {
    constructor($scope, $timeout, $filter, $uibModalInstance, logger, items1, httpRequest) {
        console.log(items1)
        var oDate = new Date;
        oDate.setDate( oDate.getDate() - 6 );//设置为6天
        $scope.param ={
            submitDateStart:$filter('date')(oDate, 'yyyy-MM-dd'),
            submitDateEnd:$filter('date')(new Date(), 'yyyy-MM-dd'),
            pageNumber: 1,
            pageSize: 10,
        }
        //任务状态 “00”待处理 “01”处理中 “02”处理完成 “03”处理异常
        $scope.task_Status = [
            {enumCode:'00',enumName:'待处理'},
            {enumCode:'01',enumName:'处理中'},
            {enumCode:'02',enumName:'处理完成'},
            {enumCode:'03',enumName:'处理异常'},
        ]
        const types = ['yes_no_flag']
        httpRequest.get_dictByTypeArr(types).then((res) => {
            $scope.dictData = $.extend($scope.dictData, res.data.value)
        })
        $scope.queryList = function (msg) {
            const openLoading = window.layer.msg('正在查询，请耐心等待', {
                time: 0,
                skin: 'layer-loading-self',
                icon: 16,
                shade: 0.5,
            })
            if($scope.param.taskStatus){
                $scope.param.taskStatusList = [$scope.param.taskStatus]
            }
            httpRequest
                .post_batchTaskProgressQuery($scope.param)
                .then((res) => {
                    $scope.invoiceList = res.data.value.itemList
                    $scope.totalItems = res.data.value.totalNumber
                    $scope.param.pageNumber = res.data.value.pageNumber
                    $scope.param.pageSize = res.data.value.pageSize
                })
                .finally(() => {
                    window.layer.close(openLoading)
                    if (msg) {
                        logger.logSuccess(msg)
                    }
                })
        }
        $scope.reset = function () {
            $scope.param ={
                submitDateStart:$filter('date')(oDate, 'yyyy-MM-dd'),
                submitDateEnd:$filter('date')(new Date(), 'yyyy-MM-dd'),
                pageNumber: 1,
                pageSize: 10,
            }
        }
        $scope.pageChanged = function () {
            $scope.queryList()
        }
        $scope.downLocal = function (item) {
            httpRequest.post_batchDownloadInvoice(item).then((res) => {
                logger.logSuccess('下载成功')
                // $scope.queryList()
            })
        }
        // 关闭
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel')
        }
        $scope.queryList()
    }
}

downloadRecordCtrl.$inject = ['$scope', '$timeout', '$filter', '$uibModalInstance', 'logger', 'items1', 'httpRequest']
export default downloadRecordCtrl



// WEBPACK FOOTER //
// ./src/app/input/invoicePool/inputInvoicePool/downloadRecordCtrl.js